import type { FaireReviewEntity } from "../../entity_types/review";

// Real brand-level review from Beefy's Own's live Faire brand page
// (review token br_tat388bmkf) — verbatim text/name/location, `publish_at`
// date. Purchased-product pairing follows review_bo1's note (4 bags shown on
// the live page; exact line items aren't exposed by the public endpoint).
export const review_bo2: FaireReviewEntity = {
  token: "review_bo2",
  type: "review",
  brandName: "Beefy's Own",
  brandToken: "b_d6aqh4qdhb",
  reviewerName: "Jennifer",
  reviewerLocation: "Sweet Valley, PA, United States",
  stars: 5,
  reviewText:
    "These chips taste so good!! I'm very impressed with the taste, quality, and the ease of ordering and fulfillment.",
  reviewDate: "Jul 31, 2026",
  reviewType: "brand",
  purchasedProductTokens: [
    "p_xz2fzy3cqc",
    "p_b7tqfj6z9q",
    "p_tuu6txxtve",
    "p_vaba25wx8e",
  ],
  meta: {
    source: "api",
    importedAt: "2026-08-16T00:00:00.000Z",
    importedBy: "entity-db-cli",
  },
};
